document.addEventListener("DOMContentLoaded", function() {

    let baseSlideCooldownSec = 4;
    let interactSlideCooldownSec = 6;
    let slideCooldownSec = baseSlideCooldownSec;

    let autoplayInterval = null;
    let isProgrammaticScroll = false;

    const slideContainer = document.querySelector(
    ".joii-product-grid-wrapper.joii-homepage-slideshow"
    );
    

    if (slideContainer) {

        const slideWrapper =
            slideContainer.closest('.product-gallery-img-wrapper') ||
            slideContainer.closest('.joii-product-grid');

        const slideDotsCont = slideWrapper.querySelector(".joii-product-grid-dots");

        let slides = Array.from(slideContainer.children);

        let userInteracting = false;
        let userCooldownTimer = null;
        let scrollEndTimer = null;

        const bufferSize = 1;
        const realStartIndex = bufferSize;
        const realEndIndex = slides.length - bufferSize;

        let index = realStartIndex;
        let isAnimating = false;

        /* ======================================================
            GROUP MAP
        ====================================================== */
        const slideMap = new Map();

        slides.forEach((el) => {
            const id = el.getAttribute("slideid");
            if (!id) return;
            if (!slideMap.has(id)) slideMap.set(id, []);
            slideMap.get(id).push(el);
        });

        /* ======================================================
            STEP
        ====================================================== */
        function getStep() {
            if (slides.length < 2) return slides[0].offsetWidth;
            const a = slides[0].getBoundingClientRect();
            const b = slides[1].getBoundingClientRect();
            return b.left - a.left;
        }

        function goToSlide(i) {
            slideContainer.style.scrollBehavior = "smooth";
            slideContainer.scrollTo({ left: i * getStep() });
        }

        /* ======================================================
            ACTIVE STATE
        ====================================================== */
        function setActiveSlideByIndex(i) {
            slides.forEach((s) => s.classList.remove("in-view"));
            const el = slides[i];
            if (!el) return;
            isProgrammaticScroll = true;
            setActiveDot(slideDotsCont, slideContainer, i);
            isProgrammaticScroll = false;
            const id = el.getAttribute("slideid");
            const group = slideMap.get(id);
            if (group) group.forEach((s) => s.classList.add("in-view"));
        }

        /* ======================================================
            LOOP RESET (single authority)
        ====================================================== */
        function loopResetIfNeeded() {
            const step = getStep();
            const scrollLeft = slideContainer.scrollLeft;
            const min = realStartIndex * step;
            const max = (realEndIndex - 1) * step;

            if (scrollLeft < min - step / 2) {
                slideContainer.style.scrollBehavior = "auto";
                index = realEndIndex - 1;
                slideContainer.scrollLeft = index * step;
                slideContainer.offsetHeight;
                slideContainer.style.scrollBehavior = "smooth";
                setActiveSlideByIndex(index);
                return true;
            }

            if (scrollLeft > max + step / 2) {
                slideContainer.style.scrollBehavior = "auto";
                index = realStartIndex;
                slideContainer.scrollLeft = index * step;
                slideContainer.offsetHeight;
                slideContainer.style.scrollBehavior = "smooth";
                setActiveSlideByIndex(index);
                return true;
            }

            return false;
        }

        /* ======================================================
            AUTOPLAY
        ====================================================== */
        function startAutoplay() {
            stopAutoplay();

            autoplayInterval = setInterval(() => {
                if (isAnimating || userInteracting) return;

                slideCooldownSec--;

                if (slideCooldownSec <= 0) {
                    nextSlide();
                    slideCooldownSec = baseSlideCooldownSec;
                }

            }, 1000);
        }
        function stopAutoplay() {
            if (autoplayInterval) {
                clearInterval(autoplayInterval);
                autoplayInterval = null;
            }
        }

        function nextSlide() {
            if (isAnimating || userInteracting) return;

            isAnimating = true;
            index++;
            setActiveSlideByIndex(index);
            goToSlide(index);
            slideCooldownSec = baseSlideCooldownSec; // reset timer here

            setTimeout(() => {
                loopResetIfNeeded();
                isAnimating = false;
            }, 600);
        }

        /* ======================================================
            INIT (FIX: prevents clone flash)
        ====================================================== */
        slideContainer.style.opacity = "0";

        //requestAnimationFrame(() => {
            // jump instantly: the container has scroll-behavior: smooth, which made the
            // slides visibly glide from the leading clone into first position on load
            slideContainer.style.scrollBehavior = "auto";
            slideContainer.scrollLeft = realStartIndex * getStep();
            slideContainer.offsetHeight;
            slideContainer.style.scrollBehavior = "smooth";
            setActiveSlideByIndex(realStartIndex);
            slideContainer.style.opacity = "1";
            startAutoplay();
        //;

        /* ======================================================
            SNAP ON SCROLL END (single source)
        ====================================================== */
        function onScrollEnd() {
            const step = getStep();

            let newIndex = Math.round(slideContainer.scrollLeft / step);
            if (newIndex >= realEndIndex) newIndex = realStartIndex;
            if (newIndex < realStartIndex) newIndex = realEndIndex - 1;

            index = newIndex;
            slideContainer.style.scrollBehavior = "smooth";
            slideContainer.scrollTo({ left: index * step });
            setActiveSlideByIndex(index);
            loopResetIfNeeded();
        }

        /* ======================================================
            SCROLL HANDLER (clean + non-fighting)
        ====================================================== */
        let lastScrollLeft = slideContainer.scrollLeft;

        slideContainer.addEventListener("scroll", () => {
            if (isAnimating) return;
            if (isProgrammaticScroll) return;

            userInteracting = true;
            clearTimeout(userCooldownTimer);

            userCooldownTimer = setTimeout(() => {
                userInteracting = false;
            }, 3000);

            const currentScroll = slideContainer.scrollLeft;

            if (Math.abs(currentScroll - lastScrollLeft) > 0.5) {
                clearTimeout(scrollEndTimer);

                scrollEndTimer = setTimeout(() => {
                onScrollEnd();
                }, 60); // fast snap, no lag
            }

            lastScrollLeft = currentScroll;
        });


        function syncCarouselState() {
            const step = getStep();
            const scrollLeft = slideContainer.scrollLeft;

            let newIndex = Math.round(scrollLeft / step);
            if (newIndex >= realEndIndex) newIndex = realStartIndex;
            if (newIndex < realStartIndex) newIndex = realEndIndex - 1;

            index = newIndex;
            setActiveSlideByIndex(index);
        }

        document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    syncCarouselState();
                });
            });
        }
        });

        window.addEventListener("focus", () => {
            syncCarouselState();
        });
    }


    function getVisibleColumnCount(container) {
        const items = Array.from(container.children);
        if (!items.length) return 0;

        const containerRect = container.getBoundingClientRect();

        const columnMap = new Map();

        // 1. group items into columns by left position
        items.forEach(item => {
            const rect = item.getBoundingClientRect();
            const key = Math.round(rect.left);

            if (!columnMap.has(key)) {
                columnMap.set(key, rect);
            }
        });

        const columns = Array.from(columnMap.values());

        let visible = 0;

        columns.forEach(rect => {
            const center = rect.left + rect.width / 2;
            const isVisible =
                center >= containerRect.left &&
                center <= containerRect.right;

            if (isVisible) visible++;
        });

        // IMPORTANT: fractional smoothing → round final result
        return Math.max(1, Math.round(visible));
    }
      
    function getTotalColumns(container) {
        const items = Array.from(container.children);
        if (!items.length) return 0;

        const columnMap = new Map();

        items.forEach(item => {
            const rect = item.getBoundingClientRect();
            const key = Math.round(rect.left);

            if (!columnMap.has(key)) {
                columnMap.set(key, true);
            }
        });

        return columnMap.size;
    }

    

    function getCurrentPageIndex(container) {
        if (!container.clientWidth) return 0;

        const visibleColumns = getVisibleColumnCount(container);
        const totalColumns = getTotalColumns(container);

        const maxScrollLeft = container.scrollWidth - container.clientWidth;
        const pageWidth = container.clientWidth;

        const isAtEnd = container.scrollLeft >= maxScrollLeft - 20;

        // ONLY use column logic for end correction
        if (isAtEnd || visibleColumns === totalColumns) {
            //return Math.round(maxScrollLeft / pageWidth) + 1;
            return Math.round(maxScrollLeft / pageWidth);
        }

        // normal case stays EXACTLY your working logic
        return Math.round(container.scrollLeft / pageWidth);
    }

    function getTotalPages(container) {
        const totalColumns = getTotalColumns(container);
        const visibleColumns = getVisibleColumnCount(container);

        if (!visibleColumns) return 0;

        return Math.ceil(totalColumns / visibleColumns);
    }


    function getActiveItemIndex(container) {

        const realItems = Array.from(container.children).filter(
            item => !item.classList.contains('is-clone')
        );

        if (!realItems.length) return 0;

        // =====================================
        // SLIDESHOW MODE
        // =====================================
        const isSlideshow =
            container.classList.contains('joii-homepage-slideshow') ||
            container.classList.contains('joii-slideshow-section');

        if (isSlideshow) {

            const containerCenter =
                container.scrollLeft + (container.clientWidth / 2);

            let closestIndex = 0;
            let closestDistance = Infinity;

            realItems.forEach((item, i) => {

                const itemCenter =
                    item.offsetLeft + (item.offsetWidth / 2);

                const distance =
                    Math.abs(containerCenter - itemCenter);

                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestIndex = i;
                }
            });

            return closestIndex;
        }

        // =====================================
        // GRID / PAGED CAROUSEL MODE
        // =====================================
        const items = Array.from(container.children);
        if (!items.length) return 0;

        const styles = getComputedStyle(container);
        const itemsPerView = parseFloat(styles.getPropertyValue('--horizontal-items')) || 1;

        const isFullWidthColumns =
          getComputedStyle(realItems[0]).width === `${container.clientWidth}px`;

        // -------------------------
        // CASE 1: 100% columns (carousel mode)
        // -------------------------
        const columnWidth = isFullWidthColumns
          ? container.clientWidth
          : container.clientWidth / itemsPerView;
        const rawIndex = container.scrollLeft / columnWidth;
        const index = Math.round(rawIndex);
        
        return Math.max(0, Math.min(realItems.length - 1, index));
    }


    // =========================
    // CLICK HANDLING (THUMBS + BUTTONS)
    // =========================
    document.addEventListener('click', (e) => {

        // =========================
        // THUMBNAIL CLICK
        // =========================
        const thumb = e.target.closest('.product-gallery-thumbnail-img .product-gallery-img-item');

        if (thumb) {
            const wrapper = thumb.closest('.product-gallery-img-wrapper');
            if (!wrapper) return;

            const container = wrapper.querySelector('.joii-product-grid-wrapper');
            if (!container) return;

            const items = Array.from(container.querySelectorAll('.product-gallery-img-item'));
            const index = Array.from(wrapper.querySelectorAll('.product-gallery-thumbnail-img .product-gallery-img-item')).indexOf(thumb);

            const target = items[index];
            if (!target) return;

            // set active thumbnail immediately
            wrapper.querySelectorAll('.product-gallery-thumbnail-img .product-gallery-img-item')
                .forEach(el => el.classList.remove('active'));

            thumb.classList.add('active');

            const thumbsContainer = thumb.closest('.product-gallery-thumbnail-img');

            if (thumbsContainer) {
                const targetScrollLeft =
                thumb.offsetLeft -
                thumbsContainer.clientWidth / 2 +
                thumb.clientWidth / 2;

                const targetScrollTop =
                thumb.offsetTop -
                thumbsContainer.clientHeight / 2 +
                thumb.clientHeight / 2;

                thumbsContainer.scrollTo({
                    left: targetScrollLeft,
                    top: targetScrollTop,
                    behavior: 'smooth'
                });
            }

            // DOT SYNC
            //setActiveDot(wrapper, index);
            const dots_cont = wrapper.querySelector('.joii-product-grid-dots');
            if (dots_cont) {
                setActiveDot(dots_cont, container);
            }

            isProgrammaticScroll = true;

            target.scrollIntoView({
                behavior: 'smooth',
                inline: 'start',
                block: 'nearest'
            });

            setTimeout(() => {
                isProgrammaticScroll = false;
            }, 600);

            return;
        }


        // =========================
        // DOT CLICK
        // =========================
        const dot = e.target.closest('.joii-product-grid-dot');

        if (dot) {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const dotsContainer = dot.closest('.joii-product-grid-dots');
            if (!dotsContainer) return;

            const wrapper =
                dotsContainer.closest('.product-gallery-img-wrapper') ||
                dotsContainer.closest('.joii-product-grid');

            if (!wrapper) return;

            const container = wrapper.querySelector('.joii-product-grid-wrapper');
            if (!container) return;

            // ALL dots
            const dots = Array.from(dotsContainer.children);
            let dotIndex;
            if (container.classList.contains("joii-homepage-slideshow")) {
                let slideCooldownSec = interactSlideCooldownSec;
                dotIndex = dots.indexOf(dot);
                goToSlide(dotIndex);

                console.log("dotIndex dot click");
                console.log(dotIndex);
                return;
            }

            dotIndex = dots.indexOf(dot);
            
            if (dotIndex < 0) return;
            // EXCLUDE clones from scroll targets
            const items = Array.from(container.children)
                .filter(el => !el.classList.contains('is-clone'));

            const mobileMode = window.matchMedia('(max-width: 767px)').matches;

            let targetScrollLeft = 0;

            // =========================
            // MOBILE: scroll by item index
            // =========================
            if (mobileMode) {
                const target = items[dotIndex];
                if (!target) return;

                targetScrollLeft = target.offsetLeft;
            } else {
                // =========================
                // DESKTOP: scroll by page width
                // =========================
                targetScrollLeft = container.clientWidth * dotIndex;
            }

            isProgrammaticScroll = true;
            container.scrollTo({
                left: targetScrollLeft,
                behavior: 'smooth'
            });
            setActiveDot(dotsContainer, container, dotIndex);
            isProgrammaticScroll = false;

            setTimeout(() => {
            }, 600);
            setTimeout(() => {
                isProgrammaticScroll = true;
            }, 1000);

            return;
        }


        // =========================
        // OFF-SCREEN SLIDE CLICK
        // =========================
        const slideItem = e.target.closest('.slideshow-item');

        if (slideItem) {
            // If already in view → allow native <a> behavior
            if (slideItem.classList.contains('in-view')) return;

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const container = slideItem.closest('.joii-product-grid-wrapper');
            if (!container) return;

            const wrapper =
                container.closest('.product-gallery-img-wrapper') ||
                container.closest('.joii-product-grid');

            // RESET ALL ACTIVE STATES
            container.querySelectorAll('.slideshow-item.in-view')
                .forEach(el => el.classList.remove('in-view'));

            const items = Array.from(container.children);

            let slideCooldownSec = interactSlideCooldownSec;

            // SET NEW ACTIVE ITEM
            slideItem.classList.add('in-view');

            isProgrammaticScroll = true;

            slideItem.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest'
            });

            setTimeout(() => {
                isProgrammaticScroll = false;
                updateButtons(container);
            }, 600);


            if (wrapper) {
                const dotsContainer = wrapper.querySelector('.joii-product-grid-dots');
                if (dotsContainer) {

                    let dotIndex;
                    if (container.classList.contains("joii-homepage-slideshow")) {
                        dotIndex = items.indexOf(slideItem);
                        if (slideItem == items[0]) {dotIndex = container.children.length;}
                        if (slideItem == items[items.length]) {dotIndex = 0;}
                        goToSlide(dotIndex);
                    }
                    //setActiveDot(dotsContainer, container);
                }
            }


            return;
        }

        // =========================
        // BUTTON CLICK
        // =========================
        const btn = e.target.closest('.grid-button-previous, .grid-button-next');
        if (btn) {

            const grid = btn.closest('.joii-product-grid');
            const container = grid.querySelector('.joii-product-grid-wrapper');

            const isPrev = btn.classList.contains('grid-button-previous');

            const maxScrollLeft = container.scrollWidth - container.clientWidth;

            // calculate next position
            let newScrollLeft = isPrev
                ? container.scrollLeft - container.clientWidth
                : container.scrollLeft + container.clientWidth;

            // clamp so it never "sticks"
            newScrollLeft = Math.max(0, Math.min(maxScrollLeft, newScrollLeft));

            container.scrollTo({
                left: newScrollLeft,
                behavior: 'smooth'
            });

            // update buttons after scroll

            setTimeout(() => {
                updateButtons(container);
                const dots_cont = grid.querySelector('.joii-product-grid-dots');
                if (dots_cont) {
                //var closestIndex = getClosestItemIndex(container);
                setActiveDot(dots_cont, container);
                }
            }, 1000);

        }

    });


    document.querySelectorAll('.variant-option').forEach(option => {
        option.addEventListener('click', () => {
            var f_id = option.getAttribute("featured-media-id") || "";
            if (f_id != "") {
                var img_match = document.querySelector(`.product-gallery-thumbnail-img #productmedia-${f_id}`) || false;
                if (img_match) {
                    img_match.click();
                }
            }
        });
    });



    // =========================
    // SCROLL → ACTIVE STATE + DOT SYNC
    // =========================
    document.querySelectorAll('.joii-product-grid-wrapper').forEach(container => {

        var galwrapper = container.closest('.product-gallery-img-wrapper');
        if (galwrapper) {
            var preselectImg = galwrapper.getAttribute("preselect-img") || "";
            if (preselectImg != "") {
                setTimeout(() => {
                    var img_match = document.querySelector(`.product-gallery-thumbnail-img #productmedia-${preselectImg}`) || false;
                    if (img_match) {
                        img_match.click();
                    }
                }, 100);
            }
        }

        container.addEventListener('scroll', () => {

            if (isProgrammaticScroll) return;
            var closestIndex = getActiveItemIndex(container);

            var wrapper = container.closest('.product-gallery-img-wrapper');
            if (wrapper) {
                // =========================
                // THUMBNAIL ACTIVE STATE
                // =========================
                //const thumbs = wrapper.querySelectorAll('.product-gallery-thumbnail-img .product-gallery-img-item');

                //thumbs.forEach(el => el.classList.remove('active'));

                // const activeThumb = thumbs[closestIndex];
                // if (activeThumb) {
                //     activeThumb.classList.add('active');

                //     const thumbsContainer = activeThumb.closest('.product-gallery-thumbnail-img');

                //     if (thumbsContainer) {
                //         const targetScrollLeft =
                //         activeThumb.offsetLeft -
                //         thumbsContainer.clientWidth / 2 +
                //         activeThumb.clientWidth / 2;

                //         const targetScrollTop =
                //         activeThumb.offsetTop -
                //         thumbsContainer.clientHeight / 2 +
                //         activeThumb.clientHeight / 2;

                //         thumbsContainer.scrollTo({
                //         left: targetScrollLeft,
                //         top: targetScrollTop,
                //         behavior: 'smooth'
                //         });
                //     }
                // }
            } else {
                wrapper = container.closest('.joii-product-grid');
            }

            if (!wrapper) return;

            // =========================
            // DOT SYNC
            // =========================
            const dots_cont = wrapper.querySelector('.joii-product-grid-dots');
            if (dots_cont) {
                setActiveDot(dots_cont, container);
            }
        });
    });


    // =========================
    // DOT HELPERS
    // =========================
    function setActiveDot(dots_cont, container, index) {
        if (isProgrammaticScroll) return;
        if (!dots_cont) return;

        if (dots_cont._updating) return;
        dots_cont._updating = true;


        var visibleCount = getVisibleColumnCount(container);
        var pages = getTotalPages(container);
        var totalColumns = getTotalColumns(container);

        //var dots = Array.from(dots_cont.querySelectorAll('.joii-product-grid-dot'));

        var mobileMode = false;
        if (window.matchMedia('(max-width: 767px)').matches) {
          mobileMode = true;
        }

        const isSlideshow =
            container.classList.contains("joii-homepage-slideshow") ||
            container.classList.contains("joii-slideshow-section");

        let totalDots;
        if (isSlideshow) {
            var realSlideItems = Array.from(container.children).filter(
                item => !item.classList.contains('is-clone')
            );

            totalDots = realSlideItems.length + 1;

            if (index === undefined) {
                index = getActiveItemIndex(container) + 1;
            }
        } else if (mobileMode) {
            totalDots = totalColumns;
            if (index === undefined) {
                index = getActiveItemIndex(container);
            }
        } else {
            totalDots = pages;
            if (index === undefined) {
                index = getCurrentPageIndex(container);
            }
        }

        //console.log(`dots_cont: ${dots_cont}, index: ${index}, pages: ${pages}, totalColumns: ${totalColumns}, visibleCount: ${visibleCount}`);
        //console.log(`container.scrollWidth: ${container.scrollWidth} container.scrollLeft: ${container.scrollLeft}  container.clientWidth: ${container.clientWidth}`);

        if (dots_cont.children.length !== totalDots) {
            //console.log(`build new dots ${dots_cont.children.length} !== ${totalDots}`);
            //console.log(dots_cont);
            //console.log(`changing dots count`);
            //console.log(`dots_cont.children: ${dots_cont.children.length}`);
            // for (let i = 0; i < dots_cont.children.length; i++) {
            //     console.log(dots_cont.children[i]);
            // }
            //console.log(`totalDots: ${totalDots}`);
            dots_cont.innerHTML = "";

            if (totalDots > 1) {
                for (let i = 0; i < totalDots; i++) {
                const el = container.children[i];

                const dot = document.createElement("div");
                dot.classList.add("joii-product-grid-dot");
                if (el.classList.contains("is-clone")) {
                    dot.style.display = "none";
                }
                dots_cont.appendChild(dot);
                }
            }
        }

        var dots = Array.from(dots_cont.children);

        if (container.clientWidth + container.scrollLeft >= container.scrollWidth - 1) {
            if (isSlideshow) {
                if (index === undefined) {
                    index = totalDots;
                }
            } else if (index + visibleCount !== totalDots) {
                index++;
            }
            //console.log(`max scroll`);
        }

        if (mobileMode) {
          dots.forEach((dot, i) => {
            dot.classList.remove('active', 'before-active', 'after-active');
            if (i >= index && i < index + visibleCount) {
              dot.classList.add('active');
            }
            if (i === index - 1) {
              dot.classList.add('before-active');
            }
            if (i === index + visibleCount) {
              dot.classList.add('after-active');
            }
          });
        } else {
          dots.forEach((dot, i) => {
            dot.classList.remove('active', 'before-active', 'after-active');
            if (i === index) {
              dot.classList.add('active');
            }
            if (i === index - 1) {
              dot.classList.add('before-active');
            }
            if (i === index + 1) {
              dot.classList.add('after-active');
            }
          });
        }

        dots_cont._updating = false;
    }


    // =========================
    // BUTTON STATE HELPER
    // =========================
    function updateButtons(container) {

        const grid = container.closest(".joii-product-grid");
        if (!grid) return;

        const mobileMode = window.matchMedia('(max-width: 767px)').matches;

        const prevBtn = grid.querySelector('.grid-button-previous');
        const nextBtn = grid.querySelector('.grid-button-next');

        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        // prevent null crashes everywhere
        if (prevBtn) {
          if (container.scrollLeft <= 10) {
            prevBtn.classList.add('disabled');
          } else {
            prevBtn.classList.remove('disabled');
          }
        }

        if (nextBtn) {
          if (container.scrollLeft >= maxScrollLeft - 1) {
            nextBtn.classList.add('disabled');
          } else {
            nextBtn.classList.remove('disabled');
          }
        }

        // MOBILE: hide safely
        if (mobileMode) {
          if (prevBtn) prevBtn.style.display = "none";
          if (nextBtn) nextBtn.style.display = "none";
          return;
        }

        // DESKTOP logic
        const bothDisabled =
          prevBtn?.classList.contains('disabled') &&
          nextBtn?.classList.contains('disabled');

        if (bothDisabled) {
          if (prevBtn) prevBtn.style.display = "none";
          if (nextBtn) nextBtn.style.display = "none";
        } else {
          if (prevBtn) prevBtn.style.display = "flex";
          if (nextBtn) nextBtn.style.display = "flex";
        }
    }


    // =========================
    // INIT
    // =========================
    function productGridUpdate() {
        document.querySelectorAll('.joii-product-grid-wrapper').forEach((container, i) => {
          try {
            //console.log('START', i);
            updateButtons(container);
            var closestIndex = getActiveItemIndex(container);
            var wrapper = container.closest('.product-gallery-img-wrapper');

            if (wrapper) {
              //console.log('img wrapper', i);
              const items = Array.from(container.querySelectorAll('.product-gallery-img-item'));

              if (items.length) {
                const thumbs = wrapper.querySelectorAll('.product-gallery-thumbnail-img .product-gallery-img-item');

                thumbs.forEach(el => el.classList.remove('active'));

                if (thumbs[closestIndex]) {
                  thumbs[closestIndex].classList.add('active');
                }
              }
            } else {
              wrapper = container.closest(`.joii-product-grid`);
            }

            if (wrapper) {
              //console.log('wrapper', i);
              //console.log(wrapper);
              const dots_cont = wrapper.querySelector('.joii-product-grid-dots');
              if (dots_cont) {
                //console.log('dots', i);
                setActiveDot(dots_cont, container);
              }
            }

          } catch (err) {
            console.error('ERROR at container index:', i, err);
          }
        });
    }
    productGridUpdate();
    
    let resizeTimeout;

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(() => {

          productGridUpdate();

          document.querySelectorAll('.joii-product-grid-wrapper').forEach(container => {

            const wrapper = container.closest('.product-gallery-img-wrapper');
            if (!wrapper) return;

            const activeThumb = wrapper.querySelector(
              '.product-gallery-thumbnail-img .product-gallery-img-item.active'
            );
            if (!activeThumb) return;

            const id = activeThumb.id || activeThumb.dataset.id;
            if (!id) return;

             const target = container.querySelector(
               `#${CSS.escape(id)}, [data-id="${id}"]`
             );

            const escapedId = window.CSS && CSS.escape
                ? CSS.escape(id)
                : id.replace(/([ #;?%&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
            if (!target) return;

            // ONLY adjust horizontal scroll
            const left = target.offsetLeft;

            container.scrollTo({
              left: left,
              behavior: 'auto'
            });

          });

        }, 150);

    });

});